import api from 'api';
import { Button, Icon } from 'b3';
import { Flex } from 'c3';
import cx from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createContact, updateContact } from '../../actions/ClientActions';
import './contact-form.less';

var mapEmailsToIdValue = (emails) => {
    var mappedEmails = emails.map(e => ({id: e.id, value: e.email}));
    return mappedEmails.length ? mappedEmails : [{value:''}];
};

var mapNumbersToIdValue = (numbers) => {
    var mappedPhoneNumbers = numbers.map(n => ({id: n.id, value: n.number}));
    return mappedPhoneNumbers.length ? mappedPhoneNumbers : [{value:''}];
};

function makeData(props) {
	var { emails = [], numbers = [] } = props;

	var emails = mapEmailsToIdValue(emails);
	var numbers = mapNumbersToIdValue(numbers);

	var {
		firstName = '',
		lastName = '',
		description = '',
		skypeUsername = '',
		isMainContact = false
	} = props;

	return {
		firstName,
		lastName,
		description,
		numbers,
		emails,
		skypeUsername,
		isMainContact
	};
}

var isRequired = input => Boolean(input);

var validationRules = {
	firstName: {
		rule: isRequired,
		msg: "First name is required, come on"
	}
};

var errorsFromInputs = (inputs, validationRules) => {
	var errors = {};

	Object.keys(validationRules).forEach(validationKey => {
		var input = inputs[validationKey];
		var validator = validationRules[validationKey];
		var passes = validator.rule(input);
		if(! passes) {
			errors[validationKey] = validator.msg;
		}
	});
	
	return errors;
};

@connect(
	state => ({}),
	{ createContact, updateContact }
)
export default class ContactForm extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			data: makeData(props),
			errors: {}
		};

		this.onInputChange = this.onInputChange.bind(this);
		this.getValidationErrors = this.getValidationErrors.bind(this);
		this.hasError = this.hasError.bind(this);
	}
	onInputChange({target}) {
		var { data } = this.state;
		data[target.name] = target.value;

		var errors = {};
		if(this.hasError()) {
			errors = this.getValidationErrors(data);
		}
		
		this.setState({data, errors});
	}
	deleteFromCollection(type, index) {
		var ensureHasItemIfAllDeleted = (arr) => ! arr.length ? [{value: ''}] : arr;

		var { data } = this.state;

		var item = data[type][index];
		if(item.id) {
			if(type == 'emails') {
				api.delete(`emails/${item.id}`);
			} else {
				api.delete(`phone_numbers/${item.id}`);
			}
		}

		data[type] = ensureHasItemIfAllDeleted(
			data[type].filter((p, i) => i != index)
		);

		this.setState({data});		
	}
	addToCollection(type) {
		var { data } = this.state;
		data[type] = data[type].concat({value:''});
		this.setState({data});
	}
	updateCollection(type, index, {target}) {
		var { data } = this.state;
		data[type][index].value = target.value;
		this.setState({data});
	}
	hasError() {
		return Boolean(
			Object.keys(this.state.errors).length
		);
	}
	getValidationErrors(data) {
		return errorsFromInputs(data, validationRules);
	}
	async save() {
		var { data } = this.state;
		var errors = this.getValidationErrors(data);
		var passes = Object.keys(errors).length == 0;

		var { id, clientId, updateContact, createContact } = this.props;

		if(passes) {
			if(id) {
				var successAction = await updateContact(id, data);
			} else {
				var successAction = await createContact(clientId, data);
			}

			this.props.onComplete(successAction.result);
		} else {
			this.setState({errors});
		}
	}
	render() {
		var { errors, data } = this.state;
		var { firstName, lastName, description, numbers, emails, skypeUsername } = data;

		return (
			<div className="my-modal-body">
				{this.hasError() &&
					<p className="need-to-fill-required-error">Please fill in the required fields</p>
				}
				
				<div className="row-wrapped">
					<div className="row-wrapped-half-col">
						<FormInput 
							autoFocus={true}
							error={errors.firstName}
							label="First Name"
							value={firstName}
							name="firstName" 
							onChange={this.onInputChange} 
							placeholder="First Name" />
					</div>
					<div className="row-wrapped-half-col">
						<FormInput 
							label="Last Name"
							value={lastName}
							name="lastName" 
							onChange={this.onInputChange} 
							placeholder="Last Name" />
					</div>
					<div className="row-wrapped-half-col">
						<FormInput 
							label="Title"
							value={description}
							name="description" 
							onChange={this.onInputChange} 
							placeholder="Title" />
					</div>
				</div>
				<Flex style={{marginTop: 15}}>
					<div className="row-wrapped-half-col">
						<div className="input-wrapper">
							<div className="input-wrapper-label">
								<i className="fa fa-phone"></i> Phone <Icon onClick={this.addToCollection.bind(this, 'numbers')} icon="add-3" />
							</div>
							<div className="vertically-stacked-inputs">
								{numbers.map((number, i) =>
									<DeletableInput key={i}
										onDelete={this.deleteFromCollection.bind(this, 'numbers', i)}
										className="c3-form-input" 
										name="email1" 
										value={number.value}
										onChange={this.updateCollection.bind(this, 'numbers', i)}
										placeholder="Phone number" />
								)}
							</div>
						</div>
					</div>
					<div className="row-wrapped-half-col">
						<div className="input-wrapper">
							<div className="input-wrapper-label">
								<i className="fa fa-email"></i> Email <Icon onClick={this.addToCollection.bind(this, 'emails')} icon="add-3" />
							</div>
							<div className="vertically-stacked-inputs">
								{emails.map((email, i) => 
									<DeletableInput key={i}
										onDelete={this.deleteFromCollection.bind(this, 'emails', i)}
										className="c3-form-input" 
										name="email1" 
										value={email.value}
										onChange={this.updateCollection.bind(this, 'emails', i)}
										placeholder="Email address" />
								)}
							</div>
						</div>
					</div>
				</Flex>
				<div className="row-wrapped">
					<div className="row-wrapped-half-col">
						<FormInput label={<div><i className="fa fa-skype"></i> Skype Username</div>} 
							name="skypeUsername" 
							value={skypeUsername}
							onChange={this.onInputChange} 
							placeholder="Skype username" />
					</div>
				</div>
				<div className="form-submit-row">
					<Button onClick={this.save.bind(this)} type="success">Save</Button>
				</div>
			</div>
		);
	}
}

function DeletableInput({onDelete, onChange, name, placeholder, value}) {
	return (
		<div className="deleteable-input">
			{value.length > 0 &&
				<div className="deleteable-input-clearout">
					<Icon onClick={onDelete} icon="cross" size={9} />
				</div>	
			}
			<input value={value}
				className="c3-form-input" 
				name={name} 
				placeholder={placeholder} 
				onChange={onChange} />
		</div>
	);
}

function FormInput({error, value, onChange, name, label, placeholder, autoFocus}) {
	var inputClassName = cx("c3-form-input", {'input-has-error': error});
	return (
		<div className="input-wrapper">
			<div className="input-wrapper-label">{label}</div>
			<input 
				autoFocus={autoFocus}
				className={inputClassName}
				value={value} 
				name={name} 
				placeholder={placeholder} 
				onChange={onChange} />
		</div>
	);
}


// WEBPACK FOOTER //
// ./app/components/contact-form/ContactForm.js